<template src="./index.html"></template>

<script>
import uploadFile from '../../../../common/uploadFile/index.vue';
import { templateFileUpload, saveReportTemplateFile } from '../../../../../api/home.js';
import { getdata } from './data.js';
export default {
	name: 'TemplateFile',
	components: {
		uploadFile
	},
	data() {
		return {
			formdata: getdata().formdata,
			formlist: getdata().formlist,
			upfile: {}
		};
	},
	mounted() {},
	methods: {
		getuploadparams(e) {
			this.upfile = e;
		},
		fordownloadmb(e) {},
		forsubmit() {
			this.$refs.taxform.submitForm();
		},
		getdata() {
			if (this.$emptyandnull(this.upfile.upfilename)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			let params = this.formdata;
			params.templateName = this.upfile.upfilename;
			saveReportTemplateFile(params).then(res => {
				if (res.data.code == '200') {
					let data = {};
					data.uploadFile = [];
					data.uploadFile[0] = this.upfile.upfile;
					data.id = res.data.data;
					templateFileUpload(data).then(res1 => {
						if (res1.data.code == '200') {
							this.$message.success('导入成功');
							this.upfile = {};
							this.$refs['uploadfileRef'].forrefresh();
						}
					});
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
